$( document ).ready(function() {
  
  
	setTimeout(function() { 
		$(".theme-money").each(function() {
         $(this).css({"opacity":"1"}); 
        });
        $(".klarna-pdp").each(function() {
         $(this).css({"opacity":"1"}); 
        });
	}, 1000);

  
  function countrycoded(countryCode){
      if(countryCode == 'JP'){
        console.log(333);
        $('[data-jp-price]').each(function(){
          var jpPrice = $(this).attr('data-jp-price');
          $(this).html(theme.Shopify.formatMoney(jpPrice * 1.4, theme.moneyFormat));
        //  $(this).closest('.product-detail__title-area').find('klarna-placement').attr('data-purchase_amount',jpPrice * 1.4);
        //  console.log(jpPrice,'jpPrice');
          
         // setTimeout(function(){
            $(this).closest('.product-detail__title-area').find('klarna-placement').attr('data-purchase_amount',jpPrice*1.4);
            window.KlarnaOnsiteService = window.KlarnaOnsiteService || [] 
            window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })
         // },500);
          
        });
        $('[data-jp-cprice]').each(function(){
          var jpcPrice = $(this).attr('data-jp-cprice');
          $(this).html(theme.Shopify.formatMoney(jpcPrice*1.4, theme.moneyFormat))
        });
        $('body').addClass('jp');
        if($('.template-product').length > 0){
          var isALARendered;
          function ALAcheck() {
            isALARendered = setInterval(function () {
              customALA()
            }, 1500);
          }
          ALAcheck();
          function customALA() {
            if($('.pv__wiw-products').length > 0){
              clearInterval(isALARendered);
              $('.pi__price').each(function(){
                var pprice = $(this).find('span').text().replace('$','').replace('.','')*1.4
				$(this).html(theme.Shopify.formatMoney(pprice));
              })
            }
          }
        } 
      } else {
      	$('body').addClass('nojp');
      }
    }
    
    $.ajax({
      url: '//get.geojs.io/v1/ip/country.json',
      type: 'GET',
      dataType: 'json',
      success: function(location) {
        var countryCode = location.country;
        setTimeout(function(){
        	countrycoded(countryCode);
        },1000)
      }
    });
    
});
	